import React from 'react';
import { Dialog, DialogProps } from '@mui/material';

interface DialogWrapperProps extends Omit<DialogProps, 'onClose'> {
  onClose: () => void;
  disableBackdropClick?: boolean;
}

export const DialogWrapper: React.FC<DialogWrapperProps> = ({
  open,
  onClose,
  disableBackdropClick = true,
  children,
  ...props
}) => {
  const handleClose = (event: {}, reason: 'backdropClick' | 'escapeKeyDown') => {
    if (disableBackdropClick && reason === 'backdropClick') {
      return;
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      disableEscapeKeyDown={false}
      {...props}
    >
      {children}
    </Dialog>
  );
};